import { createFileRoute } from "@tanstack/react-router";
import { ToastExamples } from "@/utils/design-system/examples-exports";

export const Route = createFileRoute("/demo/design-system/interactive/toast")({
  component: ToastExamples,
});
